export default __webpack_public_path__ + "static/media/howsell-2.dcdd11ef.svg";